import { NavItems } from './nav-item/nav-item';
import { sidebarElements } from './sidebar-elements';
import { UserRole } from '@reenstudio/app/core/enum/user-role';

export const navItems: NavItems = {
  [UserRole.SITE]: [
    // {
    //   navCap: '',
    // },
    sidebarElements.dashboard,
    sidebarElements.history,
    sidebarElements.forecast,
    // sidebarElements.stats,
  ],
  [UserRole.CER]: [
    // {
    //   navCap: '',
    // },
    sidebarElements.dashboard,
    sidebarElements.history,
    sidebarElements.forecast,
    sidebarElements.meterReadings,
    sidebarElements.incentive,
    sidebarElements.settings,
    // sidebarElements.stats,
  ],
  [UserRole.ADMIN]: [
    // {
    //   navCap: '',
    // },
    sidebarElements.dashboard,
    sidebarElements.history,
    sidebarElements.forecast,
    sidebarElements.meterReadings,
    // sidebarElements.stats,
    sidebarElements.incentive,
    sidebarElements.admin,
  ],
  [UserRole.INTRAPRESA]: [],
};
